jQueryCallbacks.push(function($)
{
	console.log('collapse');
	
	$('.blockEditContent [data-faq-style="collapse"] .question').each(function()
	{
		$(this).click(function()
		{
			var box = $(this).parent();
							
			if(box.is('.open'))
			{
				box.find('.answer').slideUp(function()
				{
					box.removeClass('open');
				});
			}
			else
			{
				box.find('.answer').slideDown(function()
				{
					box.addClass('open');
				});
			}
		});
	});
});